import { render, staticRenderFns } from "./ShortSummary.vue?vue&type=template&id=51e93002&scoped=true"
import script from "./ShortSummary.vue?vue&type=script&lang=js"
export * from "./ShortSummary.vue?vue&type=script&lang=js"
import style0 from "./ShortSummary.vue?vue&type=style&index=0&id=51e93002&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e93002",
  null
  
)

export default component.exports